// progress-bundle.js
// Funcionalidade para o Progress Bundle com seleção de variantes

class ProgressBundle {
  constructor(container) {
    this.container = container;
    this.productId = container.dataset.productId;
    this.productHandle = container.dataset.productHandle;
    this.basePrice = parseFloat(container.dataset.basePrice) / 100;
    this.comparePrice = parseFloat(container.dataset.comparePrice) / 100;

    // Parsear níveis de desconto
    this.levels = this.parseLevels(container.dataset.levels);

    // Estado das quantidades por variante
    this.variantQuantities = {};

    // Elementos do DOM
    this.progressFill = container.querySelector('.progress-bundle__progress-fill');
    this.levelElements = container.querySelectorAll('.progress-bundle__level');
    this.variantItems = container.querySelectorAll('.progress-bundle__variant-item');
    this.priceEachValue = container.querySelector('.progress-bundle__price-each-value');
    this.priceOriginal = container.querySelector('.progress-bundle__price-original');
    this.priceFinal = container.querySelector('.progress-bundle__price-final');
    this.discountBadge = container.querySelector('.progress-bundle__discount-badge');
    this.buyButton = container.querySelector('.progress-bundle__buy-btn');

    //Preço das variantes
    this.variantPrices = {};
    this.container.querySelectorAll('.progress-bundle__variant-item')
      .forEach(item => {
        const variantId = item.dataset.variantId;
        const price = parseFloat(item.dataset.variantPrice) /100;

        this.variantPrices[variantId] = price;
      });

    this.init();
  }

  parseLevels(levelsData) {
    if (!levelsData) return [];

    const levels = [];
    const pairs = levelsData.split(',').filter(p => p.trim());

    pairs.forEach(pair => {
      const [quantity, discount] = pair.split(':');
      if (quantity && discount !== undefined) {
        levels.push({
          quantity: parseInt(quantity),
          discount: parseInt(discount)
        });
      }
    });

    // Ordenar por quantidade
    levels.sort((a, b) => a.quantity - b.quantity);
    return levels;
  }

  init() {
    this.bindEvents();
    this.updateUI();
  }

  bindEvents() {
    // Botões de adicionar
    this.container.querySelectorAll('.progress-bundle__add-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const variantId = btn.dataset.variantId;
        this.addVariant(variantId);
      });
    });

    // Botões de mais
    this.container.querySelectorAll('.progress-bundle__qty-plus').forEach(btn => {
      btn.addEventListener('click', () => {
        const variantId = btn.dataset.variantId;
        this.incrementVariant(variantId);
      });
    });

    // Botões de menos
    this.container.querySelectorAll('.progress-bundle__qty-minus').forEach(btn => {
      btn.addEventListener('click', () => {
        const variantId = btn.dataset.variantId;
        this.decrementVariant(variantId);
      });
    });

    // Botão de compra
    this.buyButton.addEventListener('click', () => {
      this.addToCart();
    });
  }

  addVariant(variantId) {
    this.variantQuantities[variantId] = 1;
    this.updateVariantUI(variantId);
    this.updateUI();
  }

  incrementVariant(variantId) {
    this.variantQuantities[variantId] = (this.variantQuantities[variantId] || 0) + 1;
    this.updateVariantUI(variantId);
    this.updateUI();
  }

  decrementVariant(variantId) {
    if (this.variantQuantities[variantId] > 0) {
      this.variantQuantities[variantId]--;

      if (this.variantQuantities[variantId] === 0) {
        delete this.variantQuantities[variantId];
      }

      this.updateVariantUI(variantId);
      this.updateUI();
    }
  }

  updateVariantUI(variantId) {
    const variantItem = this.container.querySelector(`.progress-bundle__variant-item[data-variant-id="${variantId}"]`);
    if (!variantItem) return;

    const addBtn = variantItem.querySelector('.progress-bundle__add-btn');
    const quantitySelector = variantItem.querySelector('.progress-bundle__quantity-selector');
    const qtyValue = variantItem.querySelector('.progress-bundle__qty-value');

    const quantity = this.variantQuantities[variantId] || 0;

    if (quantity > 0) {
      addBtn.style.display = 'none';
      quantitySelector.style.display = 'flex';
      qtyValue.textContent = quantity;
      variantItem.classList.add('has-quantity');
    } else {
      addBtn.style.display = 'block';
      quantitySelector.style.display = 'none';
      variantItem.classList.remove('has-quantity');
    }
  }

  getTotalQuantity() {
    return Object.values(this.variantQuantities).reduce((sum, qty) => sum + qty, 0);
  }

  getCurrentDiscount() {
    const totalQty = this.getTotalQuantity();

    // Encontrar o maior nível atingido
    let currentDiscount = 0;

    for (const level of this.levels) {
      if (totalQty >= level.quantity) {
        currentDiscount = level.discount;
      }
    }

    return currentDiscount;
  }

  updateProgressBar() {
    const totalQty = this.getTotalQuantity();

    if (this.levels.length === 0) return;

    const maxLevel = this.levels[this.levels.length - 1];
    const minLevel = this.levels[0];

    // Calcular progresso como porcentagem
    let progress = 0;

    if (totalQty >= maxLevel.quantity) {
      progress = 100;
    } else if (totalQty > 0) {
      // Encontrar em qual segmento estamos
      for (let i = 0; i < this.levels.length; i++) {
        const currentLevel = this.levels[i];
        const nextLevel = this.levels[i + 1];

        if (totalQty >= currentLevel.quantity) {
          if (!nextLevel || totalQty < nextLevel.quantity) {
            // Estamos neste segmento
            const segmentStart = (i / (this.levels.length - 1)) * 100;
            const segmentEnd = ((i + 1) / (this.levels.length - 1)) * 100;

            if (nextLevel) {
              const segmentProgress = (totalQty - currentLevel.quantity) / (nextLevel.quantity - currentLevel.quantity);
              progress = segmentStart + (segmentEnd - segmentStart) * segmentProgress;
            } else {
              progress = 100;
            }
            break;
          }
        }
      }

      // Se ainda não atingiu o primeiro nível
      if (totalQty < minLevel.quantity) {
        const firstSegmentEnd = (1 / (this.levels.length)) * 100;
        progress = (totalQty / minLevel.quantity) * firstSegmentEnd;
      }
    }

    this.progressFill.style.width = `${Math.min(progress, 100)}%`;

    // Atualizar classes dos níveis
    this.levelElements.forEach(levelEl => {
      const levelQty = parseInt(levelEl.dataset.quantity);
      if (totalQty >= levelQty) {
        levelEl.classList.add('active');
      } else {
        levelEl.classList.remove('active');
      }
    });
  }

updatePricing() {
  const totalQty = this.getTotalQuantity();
  const discount = this.getCurrentDiscount();

  let totalOriginal = 0;

  // Somar preço real de cada variante
  for (const [variantId, quantity] of Object.entries(this.variantQuantities)) {
    if (quantity > 0) {
      const variantPrice = this.variantPrices[variantId] || 0;
      totalOriginal += variantPrice * quantity;
    }
  }

  const discountMultiplier = 1 - (discount / 100);
  const totalFinal = totalOriginal * discountMultiplier;

  const priceEach = totalQty > 0 ? totalFinal / totalQty : 0;

  // Atualizar DOM
  this.priceEachValue.textContent = this.formatPrice(priceEach);
  this.priceFinal.textContent = this.formatPrice(totalFinal);

  if (discount > 0 && totalQty > 0) {
    this.priceOriginal.textContent = this.formatPrice(totalOriginal);
    this.priceOriginal.style.display = 'inline';
    this.discountBadge.textContent = `${discount}% OFF`;
    this.discountBadge.style.display = 'inline';
  } else {
    this.priceOriginal.style.display = 'none';
    this.discountBadge.style.display = 'none';
  }

  this.buyButton.disabled = totalQty === 0;
}

  updateUI() {
    this.updateProgressBar();
    this.updatePricing();
  }

  formatPrice(price) {
    return 'R$' + price.toFixed(2).replace('.', ',');
  }

  async addToCart() {
    const totalQty = this.getTotalQuantity();
    if (totalQty === 0) return;

    // Prevenir múltiplos cliques
    if (this.buyButton.disabled) return;

    const originalText = this.buyButton.textContent;
    this.buyButton.disabled = true;
    this.buyButton.textContent = 'Adicionando...';

    try {
      // Montar array de itens para adicionar
      const items = [];

      for (const [variantId, quantity] of Object.entries(this.variantQuantities)) {
        if (quantity > 0) {
          items.push({
            id: parseInt(variantId),
            quantity: quantity
          });
        }
      }

      // Adicionar todos os itens ao carrinho
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      if (response.ok) {
        // Sucesso
        this.buyButton.textContent = '✓ Adicionado!';
        this.buyButton.style.background = '#4CAF50';

        // Atualizar estado do carrinho
        const cartState = await this.getCartState();
        this.triggerCartUpdate(cartState);
        this.updateCartComponent();

        // Abrir drawer do carrinho
        setTimeout(() => {
          this.openCartDrawer();
        }, 500);

        // Restaurar botão após 2s
        setTimeout(() => {
          this.restoreButton(originalText);
        }, 2000);

      } else {
        const errorData = await response.json();
        throw new Error(errorData.description || 'Erro ao adicionar ao carrinho');
      }

    } catch (error) {
      console.error('Erro ao adicionar ao carrinho:', error);
      this.buyButton.textContent = 'Erro - Tente novamente';
      this.buyButton.style.background = '#f44336';

      setTimeout(() => {
        this.restoreButton(originalText);
      }, 3000);
    }
  }

  restoreButton(originalText) {
    this.buyButton.disabled = this.getTotalQuantity() === 0;
    this.buyButton.textContent = originalText;
    this.buyButton.style.background = '';
  }

  async getCartState() {
    try {
      const response = await fetch('/cart.js');
      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar estado do carrinho:', error);
      return null;
    }
  }

  triggerCartUpdate(cartState) {
    if (!cartState) return;

    const eventData = {
      data: {
        itemCount: cartState.item_count,
        source: 'progress-bundle-component',
        cart: cartState
      }
    };

    const eventVariations = [
      'theme:cart-update',
      'cart:update',
      'cartUpdate',
      'cart-update'
    ];

    eventVariations.forEach(eventName => {
      const event = new CustomEvent(eventName, {
        detail: eventData,
        bubbles: true
      });
      document.dispatchEvent(event);
    });
  }

  updateCartComponent() {
    try {
      const cartItemsComponent = document.querySelector('cart-items-component');
      if (cartItemsComponent) {
        if (typeof cartItemsComponent.refresh === 'function') {
          cartItemsComponent.refresh();
        } else if (typeof cartItemsComponent.updateCart === 'function') {
          cartItemsComponent.updateCart();
        } else if (typeof cartItemsComponent.render === 'function') {
          cartItemsComponent.render();
        }
      }
    } catch (error) {
      console.error('Erro ao atualizar cart-items-component:', error);
    }
  }

  openCartDrawer() {
    // Horizon theme
    const cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer) {
      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
        return;
      }
      if (typeof cartDrawer.showDialog === 'function') {
        cartDrawer.showDialog();
        return;
      }
      const openButton = cartDrawer.querySelector('button[on\\:click="/open"]');
      if (openButton) {
        openButton.click();
        return;
      }
    }

    // Dawn theme fallback
    const cartDrawerDawn = document.querySelector('cart-drawer');
    if (cartDrawerDawn && typeof cartDrawerDawn.open === 'function') {
      cartDrawerDawn.open();
      return;
    }

    // Fallback final
    const cartIcon = document.querySelector('#cart-icon-bubble, [data-cart-toggle], cart-icon');
    if (cartIcon) {
      cartIcon.click();
    }
  }
}

// Inicialização
function initProgressBundles() {
  const bundles = document.querySelectorAll('.progress-bundle');
  bundles.forEach(bundle => {
    if (!bundle.dataset.initialized) {
      new ProgressBundle(bundle);
      bundle.dataset.initialized = 'true';
    }
  });
}

// Auto-inicializar
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProgressBundles);
} else {
  initProgressBundles();
}

// Re-inicializar para Theme Editor
document.addEventListener('shopify:section:load', (event) => {
  const section = event.target;
  const bundles = section.querySelectorAll('.progress-bundle');
  bundles.forEach(bundle => {
    bundle.dataset.initialized = '';
    new ProgressBundle(bundle);
    bundle.dataset.initialized = 'true';
  });
});

// Exportar para uso global
window.ProgressBundle = ProgressBundle;
